import { render, staticRenderFns } from "./courseworks-details.vue?vue&type=template&id=7cad6c57&scoped=true"
import script from "./courseworks-details.vue?vue&type=script&lang=js"
export * from "./courseworks-details.vue?vue&type=script&lang=js"
import style0 from "./courseworks-details.vue?vue&type=style&index=0&id=7cad6c57&prod&scoped=true&lang=css"
import style1 from "./courseworks-details.vue?vue&type=style&index=1&id=7cad6c57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cad6c57",
  null
  
)

export default component.exports